<template>
    <div :id='modal_id' class='modal-overlay hidden' @click='closeOnBackdropClick'>
        <div class='modal' :style="{'background-color' : modal_background_colour}" @click.stop='' :class="classObject">
            <div class='modal-header'>
                <div class='modal-title'>{{title}}</div>
                <div class='close-icon' @click='closeModal'><i class="fa-regular fa-xmark"></i></div>
            </div>
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: ['modal_id', 'title', 'size', 'disable_close_on_backdrop_click', 'full_screen', 'all_screen', 'modal_background_colour'],
    emits: ['modalClosed'],
    computed: {
        classObject() {
            return {
                'xxl': this.size == 'xxl',
                'xl': this.size == 'xl',
                'lg': this.size == 'lg',
                'md': this.size == 'md',
                'sm': this.size == 'sm',
                'full-screen' : this.full_screen,
                'all-screen' : this.all_screen
            }
        }
    },
    methods:{
        closeModal(){
            document.getElementById(this.modal_id).classList.add('hidden');
            this.$emit('modalClosed');
        },
        closeOnBackdropClick(){
            if(!this.disable_close_on_backdrop_click){
                this.closeModal();
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.modal-overlay{
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 100;
    visibility: visible;
    opacity: 1;
    transition: visibility 0s, opacity 0.3s linear;
}

.modal-overlay.hidden{
    opacity: 0;
    visibility: hidden;
    transition: visibility 0s, opacity 0.3s linear;
}

.modal{
    max-height: 80dvh;
    margin: 3% auto;
    height: auto;
    background-color: white;
    padding: 30px 50px 30px 50px;
    // box-sizing: border-box;
    overflow-y: auto;
    scrollbar-width: thin; //Firefox only
    scrollbar-color: darkgrey white; //Firefox only
    position: relative;
}

.full-screen{
    margin: 1% auto;
    max-height: 85dvh;
}

.all-screen{
    margin: 0;
    height: 100dvh;
    max-height: 100dvh;
    width: 100%;
}

.modal::-webkit-scrollbar { //Chrome, Edge, and Safari 
  width: 0.5rem;
}
 
.modal::-webkit-scrollbar-track { //Chrome, Edge, and Safari 
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 5px;
}
 
.modal::-webkit-scrollbar-thumb { //Chrome, Edge, and Safari 
  background-color: darkgrey;
  border-radius: 10px;
}

.modal-header{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
}

.modal-title{
    font-size: 1.6rem;
    color: var(--black);
}

.close-icon{
    font-size: 1.8rem;
    color: var(--black);
    cursor: pointer;
}

.xxl{
    width: 85%;
}

.xl{
    width: 70%;
}

.lg{
    width: 50%;

    @media(max-width:1000px){
        width: 70%;
    }
}

.md{
    width: 30%;

    @media(max-width:1400px){
        width: 50%;
    }

    @media(max-width:1000px){
        width: 70%;
    }
}

.sm{
    width: 20%;

    @media(max-width:1400px){
        width: 50%;
    }

    @media(max-width:1400px){
        width: 50%;
    }

    @media(max-width:1000px){
        width: 70%;
    }
}
</style>